<template>
  <div class="thankyou-container">
    <div class="w100">
      <wrap-container class="grid-container grid-container--6-6">
        <wrap-container class="col1" v-if="codigoError === '01'">
          <h3>
            Tus datos ya están registrados
            <br />
          </h3>
          <br />
          <p>{{ nombre }}, {{ error }}</p>
          <br />
        </wrap-container>
        <wrap-container class="col1" v-if="codigoError === '02'">
          <h3>
            Estás cerca de cobrar tu jubilación de ANSES en BBVA
            <br />
          </h3>
          <br />
          <p>{{ nombre }}, {{ error }}</p>
          <br />
          <promo-alert />
        </wrap-container>
        <wrap-container class="col1" v-if="codigoError === '03'">
          <h3>
            ¡Estás un paso más cerca!
            <br />
            Acreditá tu jubilación en BBVA y te regalamos otra de $160.000
          </h3>
          <br />
          <p>{{ nombre }}, {{ error }}</p>
          <br />
          <promo-alert />
        </wrap-container>
        <wrap-container class="col2">
          <img src="@/assets/img/gift.png" class="gift" alt="" />
        </wrap-container>
      </wrap-container>
      <swiper />
    </div>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import errores from "@/config/constants/errores";
import PromoAlert from "@/components/core/PromoAlert";
import Swiper from "@/components/core/Swiper";
export default {
  name: "Mensaje",
  components: { WrapContainer, PromoAlert, Swiper },
  computed: {
    error() {
      return errores[this.$route.params.mje].mensaje;
    },
    codigoError() {
      return errores[this.$route.params.mje].codigo;
    },
    nombre() {
      return this.$store.getters.getPaso1().nombre;
    }
  },
  mounted() {
    this.gtmOnSystemError(this.error, this.$route.params.mje);
  }
};
</script>

<style scoped>
div.sales-button {
  width: 212px;
  height: 56px;
}

p.nombre {
  font-size: 28px;
  margin-bottom: 45px;
  margin-bottom: 32px;
}

div.mensaje-wrapper {
  color: #121212;
  font-size: 18px;
  margin-top: 16px;
  margin-bottom: 42px;
}

div.button-container {
  text-align: center;
}

.gift {
  width: 25%;
  left: 30%;
  top: 0%;
  position: relative;
}

.img-menu {
  position: relative;
  left: 25%;
}

img {
  width: 50%;
}

div.thankyou-container {
  color: black;
  text-align: left;
  padding-bottom: 100px;
}

p.header {
  font-size: 27px;
}

p.titulo-detalle {
  font-size: 20px;
  font-family: BentonSansBBVA-Medium;
}

@media screen and (min-width: 600px) {
  .thankyou-inner-container {
    display: flex;
  }
  .w50:first-child {
    padding-right: 20px;
  }
  .w50:last-child {
    padding-left: 20px;
    padding-top: 122px; /* Alineación de título "próximos pasos" */
    padding-right: 50px; /* Evitar ser tapado por flotante ayuda */
  }
  .titulo-detalle {
    margin-top: 0;
  }
  div.wrap-container {
    padding-bottom: 6px;
  }

  div.paddingbot {
    padding-bottom: 70px;
  }

  div.espaciadoLineas {
    line-height: 25px;
  }
}

@media screen and (max-width: 600px) {
  div.separadoLineas {
    line-height: 80px;
  }

  div.h70 {
    height: 70px;
  }

  div.h40 {
    height: 40px;
  }

  div.h90 {
    height: 90px;
  }

  div.h110 {
    height: 110px;
  }

  div.espaciadoMobile {
    line-height: 25px;
  }

  div.h50 {
    padding-bottom: 50px;
  }
}
</style>
